import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import {buildIssueViewerRoute as buildPrimaryIssueViewerRoute} from '@github-ui/preheat-issues-manager/issue-viewer-query'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {IssueViewerPageQuery} from '@github-ui/server-persisted-queries/types/IssueViewerPage'

import {repoRouteBuilder} from '../config/repo-route-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type IssueViewerPayload = RepositoryDataResponse<IssueViewerPageQuery>

export function buildIssueViewerRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return buildPrimaryIssueViewerRoute(appBuilder)
}

export const issueViewerRoute = buildIssueViewerRoute(repoRouteBuilder)
